/* eslint-disable @typescript-eslint/no-explicit-any */
import { IBaseHeader } from '../headers/BaseHeader';

export const mapHeader = (header: IBaseHeader): any => {
	return {
		Authorization: header.authorization,
		'Content-Type': header.contentType,
	} as any;
};
